const products_on_page = document.querySelector('ul.product-grid');
const nextUrl = document.getElementById('paginateNext') || null;
let next_url = nextUrl?.dataset.nextUrl;

const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
async function getNextPage() {
    try {
        let res = await fetch(next_url);
        return await res.text();
    } catch (error) {
        console.log(error);
    }
}

async function loadMoreProducts() {
    load_more_btn.style.display = 'none';
    load_more_spinner.classList.remove('hidden');

    let nextPage = await getNextPage(); // fetches HTML from next_url
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

    load_more_spinner.classList.add('hidden');

    // Grab the new products from the newly fetched HTML:
    const newProductGrid = nextPageDoc.getElementById('product-grid');
    const newProducts = newProductGrid.getElementsByClassName('grid__item');

    // IMPORTANT: Grab the updated paginateNext from the *new* HTML doc:
    const newPaginateNext = nextPageDoc.getElementById('paginateNext');
    const new_url = newPaginateNext ? newPaginateNext.dataset.nextUrl : null;

    // If there's a next page, show the "Load More" button again
    if (new_url) {
        load_more_btn.style.display = 'flex';
    }
    // Otherwise, maybe hide the button for good
    else {
        load_more_btn.style.display = 'none';
    }

    // Update our global next_url
    next_url = new_url;
    const newProductsArray = Array.from(newProducts);

    newProductsArray.forEach(product => {
        products_on_page.appendChild(product);
    });
}
